/**
 * Sort an array of objects by a field.
 * @param {Array} array - Array to sort
 * @param {string} field - Object key to sort by
 * @param {'asc' | 'desc'} [order='asc'] - Sort order
 * @returns {Array} New sorted array
 */
export function sortByField(array, field, order = 'asc') {
  const sorted = [...array].sort((a, b) => {
    const aVal = a[field];
    const bVal = b[field];

    if (aVal == null) return 1;
    if (bVal == null) return -1;

    if (typeof aVal === "string") {
      return order === "asc"
        ? aVal.localeCompare(bVal)
        : bVal.localeCompare(aVal);
    }

    return order === "asc" ? aVal - bVal : bVal - aVal;
  });

  return sorted;
}